import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class DigitalServiceRepository extends CrudRepository {
  constructor () {
    super('core/api/services/details/')
  }

  async getDigialServices (id, gsm) {
    if (gsm !== null) {
      const formData = new FormData()
      formData.append('gsm', gsm)
      // console.log('There is a gsm')
      const data = await Repository.post(`${this.resource}${id}`, formData)
      return data.data
    } else {
      // console.log('no gsm')
      const type = {
        headers: {
          'user-type': 'guest'
        }
      }
      const data = await Repository.post(`${this.resource}${id}`, {}, type)
      return data.data
    }
  }
}
